import { Trans } from '~/common/context';
import { Button, Flex, Text, Title } from '@wyz/ui';
import React from 'react';
import { Link } from 'react-router';

function CartEmpty({ to = '..' }: { to?: string }) {
  return (
    <Flex direction='column' alignItems='center'>
      <Background className='my-5' />
      <Title heading='xl' weight='bold' color='tertiary' className='mb-2'>
        <Trans i18nKey='app.purchase.cart_page.empty_cart' />
      </Title>
      <Title className='mb-4'>
        <Trans i18nKey='app.purchase.cart_page.empty_cart_message' />
      </Title>
      <Button id='back-to-search-empty' variant='primary' as={Link} to={to}>
        <Text heading='normal' weight='semi-bold' color='white'>
          <Trans i18nKey='app.purchase.cart_page.back_to_search' />
        </Text>
      </Button>
    </Flex>
  );
}

export default CartEmpty;

function Background(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='581'
      height='400'
      viewBox='0 0 581 400'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_2762_66231)'>
        <path
          d='M783.342 387C783.342 388.447 782.713 390.017 781.201 391.731C779.68 393.456 777.339 395.237 774.13 397.043C767.713 400.654 758.142 404.19 745.665 407.587C720.737 414.374 684.588 420.504 639.828 425.658C550.331 435.964 426.648 442.342 290 442.342C153.352 442.342 29.6686 435.964 -59.8282 425.658C-104.588 420.504 -140.737 414.374 -165.665 407.587C-178.142 404.19 -187.713 400.654 -194.13 397.043C-197.339 395.237 -199.68 393.456 -201.201 391.731C-202.713 390.017 -203.342 388.447 -203.342 387C-203.342 385.553 -202.713 383.983 -201.201 382.269C-199.68 380.544 -197.339 378.763 -194.13 376.957C-187.713 373.346 -178.142 369.81 -165.665 366.413C-140.737 359.626 -104.588 353.496 -59.8282 348.342C29.6686 338.036 153.352 331.658 290 331.658C426.648 331.658 550.331 338.036 639.828 348.342C684.588 353.496 720.737 359.626 745.665 366.413C758.142 369.81 767.713 373.346 774.13 376.957C777.339 378.763 779.68 380.544 781.201 382.269C782.713 383.983 783.342 385.553 783.342 387Z'
          stroke='#ABBAC9'
          strokeWidth='3.31596'
        />
        <path
          d='M1094.34 305C1094.34 313.673 1089.14 322.417 1078.57 331.13C1068.02 339.827 1052.37 348.291 1032.05 356.397C991.421 372.604 932.536 387.234 859.652 399.532C713.911 424.123 512.508 439.342 290 439.342C67.4923 439.342 -133.911 424.123 -279.652 399.532C-352.536 387.234 -411.421 372.604 -452.046 356.397C-472.367 348.291 -488.023 339.827 -498.57 331.13C-509.136 322.417 -514.342 313.673 -514.342 305C-514.342 296.327 -509.136 287.583 -498.57 278.87C-488.023 270.173 -472.367 261.709 -452.046 253.603C-411.421 237.396 -352.536 222.766 -279.652 210.468C-133.911 185.877 67.4923 170.658 290 170.658C512.508 170.658 713.911 185.877 859.652 210.468C932.536 222.766 991.421 237.396 1032.05 253.603C1052.37 261.709 1068.02 270.173 1078.57 278.87C1089.14 287.583 1094.34 296.327 1094.34 305Z'
          stroke='#ABBAC9'
          strokeWidth='3.31596'
        />
        <ellipse
          cx='290'
          cy='389.5'
          rx='806'
          ry='136.5'
          stroke='#ABBAC9'
          strokeWidth='3.31596'
          strokeLinecap='round'
          strokeDasharray='82.9 82.9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M460.65 43.7026L399.227 55.356V92.6826L460.65 81.028V43.7026Z'
          fill='#7A90A9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M460.649 43.703L504.904 58.979V96.3057L460.649 81.0283V43.703Z'
          fill='#99AABD'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M399.227 55.356L444.27 74.5707V154.263L399.227 135.048V55.356Z'
          fill='#B8C4D1'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M399.227 55.3566L444.27 74.5713L429.154 87.3214C427.334 88.8569 424.778 89.1705 422.64 88.1205L399.227 76.6193V55.3566Z'
          fill='#7A90A9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M504.904 58.9787L444.27 74.5707V154.263L504.904 138.513V58.9787Z'
          fill='#CED6DF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M504.904 58.9791L444.27 74.5711L457.795 87.6991C459.361 89.2195 461.63 89.7692 463.718 89.1345L504.904 76.6191V58.9791Z'
          fill='#7A90A9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M399.227 55.3562L444.27 74.5709L425.843 86.2256L380.643 67.1682L399.227 55.3562Z'
          fill='#CED6DF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M504.904 58.9789L444.27 74.5709L462.696 86.2256L523.331 70.6336L504.904 58.9789Z'
          fill='#CED6DF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M479.076 31.8906L523.331 47.1665L504.904 58.9785L460.649 43.7025L479.076 31.8906Z'
          fill='#B8C4D1'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M446.16 30.0005L382.69 40.0805L399.227 55.3564L460.65 43.7031L446.16 30.0005Z'
          fill='#CED6DF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M399.227 55.356L427.418 67.3266L408.834 79.1387L380.643 67.168L399.227 55.356Z'
          fill='#B8C4D1'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M446.16 29.9999L408.519 35.9852L424.268 50.6318L460.65 43.7025L446.16 29.9999Z'
          fill='#B8C4D1'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M167.147 303.783L217.059 325.175V358.566L167.147 337.175V303.783Z'
          fill='#99AABD'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M167.147 303.783L98.973 322.044V355.436L167.147 337.174V303.783Z'
          fill='#7A90A9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M217.059 358.566L149.059 377L98.973 355.436L167.147 337.175L217.059 358.566Z'
          fill='#546A82'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M98.973 322.045L149.059 343.61V377L98.973 355.436V322.045Z'
          fill='#B8C4D1'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M217.059 325.175L149.059 343.61V377L217.059 358.566V325.175Z'
          fill='#CED6DF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M179.146 335.436L207.32 341.522L217.059 354.913V358.566L204.363 362.044L175.669 336.48L179.146 335.436Z'
          fill='#A2B2C3'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M162.276 301.001L207.319 337.696L202.45 354.566L157.407 317.871L162.276 301.001Z'
          fill='#B8C4D1'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M282.624 338.913L207.32 337.695L202.451 354.565L277.755 355.783L282.624 338.913Z'
          fill='#CED6DF'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M237.581 302.217L162.276 301L207.32 337.695L282.624 338.913L237.581 302.217Z'
          fill='#E3E8ED'
        />
      </g>
      <defs>
        <clipPath id='clip0_2762_66231'>
          <rect
            width='580'
            height='400'
            fill='white'
            transform='translate(0.642578)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
